export default __webpack_public_path__ + "static/montgolfiere-74ebcb73328e56312683e68bcf218b71.webp";